import './Styles/Share.scss';
import {ReactComponent as Icon1} from '../../../Assets/Icons/share1.svg';
import {ReactComponent as Icon2} from '../../../Assets/Icons/share2.svg';
import {ReactComponent as Icon3} from '../../../Assets/Icons/share3.svg';
import image from '../../../Assets/Cards/sharePrototype.webp';
export const icons = [
    {
        icon:<Icon1 />,
        title:"Add transitions and gestures",
        desc:"Create realistic user experiences with our built in interactions for web and mobile devices."
    },
    {
        icon:<Icon2 />,
        title:"Support for every screen",
        desc:"Prototype for desktop, iPhone, iPad, Apple TV, Apple Watch and Android devices. If it has a screen, Marvel supports it."
    },
    {
        icon:<Icon3/>,
        title:"Offline downloads",
        desc:"Work without worry, present your prototypes without wifi, 3G or any other connectivity."
    }
]
function Share(){
    return(
        <div className="share-prototype">
            <div className="content">
                <h1>Share and present, anywhere</h1>
                <p>Fast URL sharing and embed codes for your mockups means you can start getting actionable feedback in no time. Quickly share your web and mobile prototypes with those who matter, whether that's your developers, clients or stakeholders.</p>
            </div>
            <div className="part">
             <ul>
                 {icons.map((item) =>{
                     return(
                         <li>
                             {item.icon}
                             <h3>{item.title}</h3>
                             <p>{item.desc}</p>
                         </li>
                     )
                 })}
             </ul>
             <img src={image} />
            </div>
        </div>
    )
};
export default Share ;